import React from 'react'
import { Outlet } from 'react-router-dom';

import TopNavbar from '../Navbars/TopNavbar/TopNavbar';
import SideNavbar from '../Navbars/SideNavbar/SideNavbar';




const Main = () => {
  return (
    <>
    <TopNavbar />
    <SideNavbar />
    <div style={{marginLeft: '231px', marginTop: '70px', backgroundColor: "rgb(240 240 240)", height: 'calc(100vh - 70px'}} className='p-3'>
        <Outlet />
    </div>
    </>
  )
}

export default Main
